<template>
    <b-modal :no-close-on-backdrop="true" :title="Core.Definition.getDefinition('Modification')" :hide-footer="true" v-model="dataShow">
        <DynamicForm
                ref="dynamicForm"
                v-model="dataId"
                @onInit="onInit"
                @onSave="onSave"
                @onInitSuccess="onInitSuccess"
                @onRequestSuccess="onRequestSuccess"
                @onSaveSuccess="onSaveSuccess"
                :ignoreRouteParamId="true"
                getRoot="/binder-audit"
                saveRoot="/binder-audit"
                :options="dataOptions"
                :formStructure="dataFormStructures.form">
            <slot slot="afterForm">

                <InputInstanceSelector
                        ref="modalInstanceSelector"
                        v-model="dataBinderIndex"
                        :label="Core.Definition.getDefinition('Sélectionnez un index')"
                        :emptyMessage="Core.Definition.getDefinition('Associez un index au registre de modification')"
                        :searchArgs="binderIndexSearchArgs"
                        :instanceSelector=" {
                        root: '/binder-index/list',
                        searchFormStructure: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'title'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'title',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Titre'),
                                    value: ''
                                }
                            ]
                        },
                        data: {},
                        options: {
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                            borderVariant: 'white',
                            noBody: true
                        },
                        columns: [
                                        {
                                            label: Core.Definition.getDefinition('Position'),
                                            key: 'position',
                                            sortable: true
                                        },
                                        {
                                            label: Core.Definition.getDefinition('Titre'),
                                            key: 'title',
                                            sortable: true
                                        }
                        ],
                        label: 'title',
                        id: 'id'
                    }"></InputInstanceSelector>

                <InputInstanceSelector
                        v-if="Core.Validation.isId(dataBinderIndex.id)"
                        ref="modalInstanceSelector"
                        v-model="dataBinderForm"
                        :label="Core.Definition.getDefinition('Sélectionnez un formulaire')"
                        :emptyMessage="Core.Definition.getDefinition('Associez un formulaire au registre de modification')"
                        :searchArgs="binderFormSearchArgs"
                        :instanceSelector="{
                        root: '/binder-form/list',
                        searchFormStructure: {
                            rows: [
                                {
                                    cols: [
                                        {
                                            fields: [
                                                {
                                                    id: 'position'
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            fields: [
                                {
                                    id: 'position',
                                    type: 'text',
                                    label: Core.Definition.getDefinition('Position'),
                                    value: ''
                                }
                            ]
                        },
                        data: {},
                        options: {
                            pagination: true,
                            header: true,
                            responsive: false,
                            striped: true,
                            headerStyle: '1',
                            emptyText: Core.Definition.getDefinition('Aucun élément à afficher'),
                            borderVariant: 'white',
                            noBody: true
                        },
                        columns: [
                                        {
                                            label: Core.Definition.getDefinition('Position'),
                                            key: 'position',
                                            sortable: true
                                        }
                        ],
                        label: 'position',
                        id: 'id'
                    }"></InputInstanceSelector>
            </slot>
        </DynamicForm>


    </b-modal>
</template>

<script>
    import DynamicForm from './DynamicForm'
    import InputInstanceSelector from './InputInstanceSelector'
    export default {
        name: 'ModalBinderAudit',
        components: {
            DynamicForm,
            InputInstanceSelector
        },
        props: {
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            },
            id: {
                set(val) {
                    this.dataId = val
                },
                get() {
                    return this.dataId
                }
            },
            binderId: {
                set(val) {
                    this.dataBinderId = val
                },
                get() {
                    return this.dataBinderId
                }
            },
            binderIndexSearchArgs: {
                set(val) {
                },
                get() {
                    let searchArgs = [{
                        key: 'binderId',
                        value: this.dataBinderId
                    }]
                    return searchArgs
                }
            },
            binderFormSearchArgs: {
                set(val) {
                },
                get() {
                    let searchArgs = [{
                            key: 'binderIndexId',
                            value: this.dataBinderIndex.id
                    }]
                    return searchArgs
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataShow: false,
                dataId: '',
                dataBinderId: '',
                dataBinderIndexId: '',
                dataBinderIndex: {},
                dataBinderForm: {},
                dataBinderFormSearchArgs: [],
                dataOptions: {
                    submit: {
                        text: 'Enregistrer',
                        variant: 'success'
                    }
                },
                dataFormStructures: {
                    form: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                options: {
                                                    class: 'card-no-body'
                                                },
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'description'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'description',
                                type: Core.Value.typeLongText,
                                label: Core.Definition.getDefinition('Description'),
                                value: ''
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInit() {
                this.$refs.dynamicForm.$refs.request.addArg('binderId', this.dataBinderId)
            },
            onSave() {
                this.$refs.dynamicForm.$refs.request.addArg('binderIndexId', this.dataBinderIndex.id)
                this.$refs.dynamicForm.$refs.request.addArg('binderFormId', this.dataBinderForm.id)
            },
            onRequestSuccess(data) {
                if (data.form !== undefined) {
                    if (data.form.binderIndex !== undefined) {
                        this.dataBinderIndex = data.form.binderIndex
                    }
                    if (data.form.binderForm !== undefined) {
                        this.dataBinderForm = data.form.binderForm
                    }
                }
            },
            onInitSuccess(data) {
                this.$emit('onInitSuccess', data)
            },
            onSaveSuccess(data) {
                this.$emit('onSaveSuccess', data)
            }
        }
    }
</script>
